const pb23SearchExtra = {
	queries: [],
    init()
    {
		// gravar no local storage
		$('.pb23-search--extra form').on('submit', function()
		{
			var q = $('.pb23-search--extra form input[name="q"]').val();
			pb23SearchExtra.queries.push(q);
			if (localStorage)
			{
				localStorage.setItem('pbSearches', JSON.stringify(pb23SearchExtra.queries));
			}
		});

		// load searchs
		if (localStorage)
		{
			var queries = localStorage.getItem('pbSearches');
			if (queries)
			{
				pb23SearchExtra.queries = JSON.parse(queries);
				console.log(queries);
				if (pb23SearchExtra.queries.length > 0)
				{
					$('.pb23-search--extra .pb23-tags').html('');
					for (var x=0;x<pb23SearchExtra.queries.length;x++)
					{
						$('.pb23-search--extra .pb23-tags').append('<li><a href="/busca/resultados/?q='+pb23SearchExtra.queries[x]+'">'+pb23SearchExtra.queries[x]+'</a></li>');
					}
				}
			}
		}

	}
}

window.initializeComponent.push({ component: "pb23-search--extra", init: pb23SearchExtra.init });

export default() => {
    pb23SearchExtra.init();
}